import React, { useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { ReportDisplayBy, ReportEntityType } from 'components/ReportsModule/types';
import { useFormikContext } from 'formik';
import DateRangeField from '../common/DateRangeField';
import DisplayByField from '../common/DisplayByField';
import SharedFilters from '../common/SharedFilters';
import ViewAsSwitch from '../common/ViewAsSwitch';
import { FilterFormValues } from '../types';

const WdtFilter: React.FC = () => {
  const showDisplayBy = useShowDisplayBy();
  const classes = useStyles();

  return (
    <>
      <SharedFilters />

      {showDisplayBy ? (
        <Grid xs={6} md={6} lg item className={classes.displayByField}>
          <DisplayByField />
        </Grid>
      ) : null}

      <Grid xs={6} md={6} lg item className={classes.dateRangeField}>
        <DateRangeField />
      </Grid>

      <Grid item>
        <ViewAsSwitch />
      </Grid>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  [theme.breakpoints.up('lg')]: {
    displayByField: {
      maxWidth: '130px'
    },
    dateRangeField: {
      minWidth: '140px',
      maxWidth: '240px'
    }
  }
}));

const useShowDisplayBy = (): boolean => {
  const { values, setFieldValue } = useFormikContext<FilterFormValues>();
  const { entityType, displayBy } = values;

  const showDisplayByField = (entityType: ReportEntityType): boolean =>
    entityType === ReportEntityType.CLASSROOM;

  useEffect(() => {
    if (!showDisplayByField(entityType)) {
      setFieldValue('displayBy', null);
    } else if (!displayBy) {
      setFieldValue('displayBy', ReportDisplayBy.STUDENTS);
    }
  }, [displayBy, entityType, setFieldValue]);

  useEffect(() => {
    // Reset field on WdtFilter unmount
    return () => setFieldValue('displayBy', null);
  }, [setFieldValue]);

  return !!displayBy;
};

export default WdtFilter;
